var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "18px",
    viewBox: "0 0 16 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-down-fill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.8333333,0 C11.2916667,0 11.6666667,0.375 11.6666667,0.833333333 L11.6666667,1.66666667 L12.5,1.66666667 C13.8783333,1.66666667 15,2.78833333 15,4.16666667 L15,14.1666667 C15,15.545 13.8783333,16.6666667 12.5,16.6666667 L2.5,16.6666667 C1.12166667,16.6666667 0,15.545 0,14.1666667 L0,4.16666667 C0,2.78833333 1.12166667,1.66666667 2.5,1.66666667 L3.33333333,1.66666667 L3.33333333,0.833333333 C3.33333333,0.375 3.70833333,0 4.16666667,0 C4.625,0 5,0.375 5,0.833333333 L5,1.66666667 L10,1.66666667 L10,0.833333333 C10,0.375 10.375,0 10.8333333,0 Z M13.3333333,9.16666667 L1.66666667,9.16666667 L1.66666667,14.1666667 C1.66666667,14.6258333 2.04083333,15 2.5,15 L12.5,15 C12.9591667,15 13.3333333,14.6258333 13.3333333,14.1666667 L13.3333333,9.16666667 Z M4.16666667,10.8333333 C4.625,10.8333333 5,11.2083333 5,11.6666667 C5,12.125 4.625,12.5 4.16666667,12.5 C3.70833333,12.5 3.33333333,12.125 3.33333333,11.6666667 C3.33333333,11.2083333 3.70833333,10.8333333 4.16666667,10.8333333 Z M10.8333333,10.8333333 C11.2916667,10.8333333 11.6666667,11.2083333 11.6666667,11.6666667 C11.6666667,12.125 11.2916667,12.5 10.8333333,12.5 L7.5,12.5 C7.04166667,12.5 6.66666667,12.125 6.66666667,11.6666667 C6.66666667,11.2083333 7.04166667,10.8333333 7.5,10.8333333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stepper-flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MacBook-Air-13\"-Copy-7",
    transform: "translate(-1284.000000, -272.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-fill",
    transform: "translate(1284.500000, 272.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor",
    fill: "#19222F",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d35891f4daca0d61c2ca3189048a4bcb.svg";
export { ForwardRef as ReactComponent };